export const CHANGE_DATES = 'CHANGE_DATES';
export const CHANGE_INTERVAL = 'CHANGE_INTERVAL';
